import type { RibbonButtonState } from ".";

export type StateWithVariant = {
  variant?: RibbonButtonState["variant"];
  variantId?: RibbonButtonState["variantId"];
};

export function useRibbonButtonVariant<T extends StateWithVariant>(
  state: T,
  variant?: T["variant"],
  variantId?: T["variantId"]
) {
  if (variant !== undefined) {
    state.variant = variant;
  }
  if (variantId !== undefined) {
    state.variantId = variantId;
  }
}
